import { HttpErrorResponse } from '@angular/common/http';
import { TileWidget } from '../../types/tile.types';

/** Beschreibung und Icon zum WMO-Wettercode von Open-Meteo. */
export function weatherCondition(code: number, isDay: boolean): { label: string; icon: string } {
  if (code === 0) return { label: isDay ? 'Sonnig' : 'Klar', icon: isDay ? 'ri-sun-line' : 'ri-moon-clear-line' };
  if (code <= 2) return { label: 'Leicht bewölkt', icon: isDay ? 'ri-sun-cloudy-line' : 'ri-moon-cloudy-line' };
  if (code === 3) return { label: 'Bedeckt', icon: 'ri-cloudy-line' };
  if (code === 45 || code === 48) return { label: 'Nebel', icon: 'ri-mist-line' };
  if (code >= 51 && code <= 57) return { label: 'Nieselregen', icon: 'ri-drizzle-line' };
  if ((code >= 61 && code <= 67) || (code >= 80 && code <= 82)) {
    return { label: code === 65 || code === 82 ? 'Starker Regen' : 'Regen', icon: code === 65 || code === 82 ? 'ri-heavy-showers-line' : 'ri-showers-line' };
  }
  if ((code >= 71 && code <= 77) || code === 85 || code === 86) return { label: 'Schnee', icon: 'ri-snowy-line' };
  if (code >= 95) return { label: 'Gewitter', icon: 'ri-thunderstorms-line' };
  return { label: 'Wechselhaft', icon: 'ri-cloud-line' };
}

/** „America/New_York“ → „New York“, leer → Ortszeit. */
export function timeZoneLabel(timeZone: string): string {
  return timeZone ? timeZone.split('/').pop()!.replaceAll('_', ' ') : 'Ortszeit';
}

/** Alle IANA-Zeitzonen des Browsers, sortiert nach Ortsname, für die Auswahl im Dialog. */
export function timeZoneOptions(): { label: string; value: string }[] {
  const zones = typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone') : ['Europe/Berlin', 'Europe/London', 'America/New_York', 'Asia/Tokyo'];
  const options = zones.map(zone => ({ label: `${timeZoneLabel(zone)} (${zone.replaceAll('_', ' ')})`, value: zone }));
  options.sort((a, b) => a.label.localeCompare(b.label, 'de'));
  return [{ label: 'Ortszeit dieses Geräts', value: '' }, ...options];
}

/** Fehlertext vom Server (Hono liefert bei HTTPException den reinen Text). */
export function serverMessage(error: unknown, fallback: string): string {
  if (error instanceof HttpErrorResponse) {
    if (typeof error.error === 'string' && error.error.trim() && error.error.length < 300) return error.error;
    if (typeof error.error?.message === 'string') return error.error.message;
  }
  return fallback;
}

/** Name, den der Server ohne eigene Angabe vergibt (server/src/tile/personal-widget.ts#widgetName). */
export function defaultWidgetName(widget: TileWidget): string {
  if (widget.type === 'weather') return `Wetter ${widget.place}`;
  if (widget.type === 'clock') return widget.timeZone ? `Uhr ${timeZoneLabel(widget.timeZone)}` : 'Uhr';
  return 'Notiz';
}
